module.exports = __webpack_public_path__ + "front/img/content1.2fe34232.png";